export default __webpack_public_path__ + "static/media/na_pt.b5b11a58.png";